export const Endpoint = Object.freeze({
	CheckListCollapse: 'CheckList.collapse',
	CheckListComplete: 'CheckList.complete',
	CheckListExpand: 'CheckList.expand',
	CheckListGet: 'CheckList.get',
	CheckListRenew: 'CheckList.renew',
	CheckListSave: 'CheckList.save',
	FileAttach: 'File.attach',
	FileDetach: 'File.detach',
	FileList: 'File.list',
	FileListObjects: 'File.listObjects',
	FlowGet: 'Flow.get',
	GroupGet: 'Group.get',
	GroupGetByTaskId: 'Group.getByTaskId',
	GroupStageList: 'Group.Stage.list',
	GroupUrlGet: 'Group.Url.get',
	LegacyCommentGet: 'LegacyComment.get',
	LegacyUserFieldGetTask: 'LegacyUserField.getTask',
	LegacyUserFieldGetTemplate: 'LegacyUserField.getTemplate',
	OptionSet: 'Option.set',
	OptionSetBool: 'Option.setBool',
	ScrumUpdateTask: 'Scrum.updateTask',
	ScrumGetTaskInfo: 'Scrum.getTaskInfo',
	TaskAdd: 'Task.add',
	TaskGet: 'Task.get',
	TaskCopy: 'Copy.Task.copy',
	TaskUpdate: 'Task.update',
	TaskDelete: 'Task.delete',
	TaskAccessGet: 'Task.Access.get',
	TaskAccessRequest: 'Task.Access.request',
	TaskAccessIsRequested: 'Task.Access.isRequested',
	TaskAttentionMute: 'Task.Attention.mute',
	TaskAttentionUnmute: 'Task.Attention.unmute',
	TaskCheckListFileList: 'Task.CheckList.File.list',
	TaskCrmItemSet: 'Task.CRM.Item.set',
	TaskCrmItemList: 'Task.CRM.Item.list',
	TaskDeadlineGetDeadlineChangeCount: 'Task.Deadline.getDeadlineChangeCount',
	TaskDeadlineCleanChangeLog: 'Task.Deadline.cleanChangeLog',
	TaskDescriptionUpdate: 'Task.Description.update',
	TaskDescriptionForceUpdate: 'Task.Description.forceUpdate',
	TaskFavoriteAdd: 'Task.Favorite.add',
	TaskFavoriteDelete: 'Task.Favorite.delete',
	TaskFromTemplateAdd: 'Template.Task.add',
	TaskFromTemplateGet: 'Template.Task.get',
	TaskResultRequire: 'Task.Result.require',
	TaskResultGet: 'Task.Result.get',
	TaskResultTail: 'Task.Result.tail',
	TaskResultGetAll: 'Task.Result.getAll',
	TaskResultAdd: 'Task.Result.add',
	TaskResultUpdate: 'Task.Result.update',
	TaskResultDelete: 'Task.Result.delete',
	TaskResultMessageAdd: 'Task.Result.Message.add',
	TaskReminderList: 'Task.Reminder.list',
	TaskReminderSet: 'Task.Reminder.set',
	TaskReminderAdd: 'Task.Reminder.add',
	TaskReminderUpdate: 'Task.Reminder.update',
	TaskReminderDelete: 'Task.Reminder.delete',
	TaskStateSet: 'Task.State.set',
	TaskDeadlineUpdate: 'Task.Deadline.update',
	TaskPlanUpdate: 'Task.Plan.update',
	TaskStakeholderResponsibleDelegate: 'Task.Stakeholder.Responsible.delegate',
	TaskMarkSet: 'Task.Mark.set',
	TaskMultiTaskAdd: 'Task.Relation.Multi.Task.add',
	TaskRelationChildGetSubTaskIds: 'Task.Relation.Child.getSubTaskIds',
	TaskRelationChildListByIds: 'Task.Relation.Child.listByIds',
	TaskRelationGanttDependenceCheck: 'Task.Relation.Gantt.Dependence.check',
	TaskRelationGanttDependenceAdd: 'Task.Relation.Gantt.Dependence.add',
	TaskRelationGanttDependenceUpdate: 'Task.Relation.Gantt.Dependence.update',
	TaskRelationGanttDependenceDelete: 'Task.Relation.Gantt.Dependence.delete',
	TaskResultFileList: 'Task.Result.File.list',
	TaskStatusStart: 'Task.Status.start',
	TaskStatusTake: 'Task.Status.take',
	TaskStatusDisapprove: 'Task.Status.disapprove',
	TaskStatusDefer: 'Task.Status.defer',
	TaskStatusApprove: 'Task.Status.approve',
	TaskStatusPause: 'Task.Status.pause',
	TaskStatusComplete: 'Task.Status.complete',
	TaskStatusRenew: 'Task.Status.renew',
	TaskTimeTrackingAdd: 'Task.Tracking.ElapsedTime.add',
	TaskTimeTrackingDelete: 'Task.Tracking.ElapsedTime.delete',
	TaskTimeTrackingList: 'Task.Tracking.ElapsedTime.list',
	TaskTimeTrackingListParticipants: 'Task.Tracking.ElapsedTime.listParticipants',
	TaskTimeTrackingUpdate: 'Task.Tracking.ElapsedTime.update',
	TaskTrackingTimerStart: 'Task.Tracking.Timer.start',
	TaskTrackingTimerStop: 'Task.Tracking.Timer.stop',
	TaskTrackingTaskWithActiveTimer: 'Task.Tracking.Timer.getTaskWithActiveTimer',
	TaskViewUserCount: 'Task.View.User.count',
	TaskViewUserTail: 'Task.View.User.tail',
	TaskReplicationAdd: 'Task.Replication.add',
	TaskReplicationSetState: 'Task.Replication.setState',
	TemplateAdd: 'Template.add',
	TemplateAddFromExistingTask: 'Task.Template.add',
	TemplateAddFromTaskEntity: 'Task.Template.addFromData',
	TemplateCopy: 'Copy.Template.copy',
	TemplateDelete: 'Template.delete',
	TemplateGet: 'Template.get',
	TemplateHistoryGetCount: 'Template.History.getCount',
	TemplateHistoryGetGrid: 'Template.History.getGrid',
	TemplateReplicationSetState: 'Template.Replication.setState',
	TemplateRelationChildAdd: 'Template.Relation.Child.add',
	TemplateRelationChildDelete: 'Template.Relation.Child.delete',
	TemplateRelationChildGetSubTemplateIds: 'Template.Relation.Child.getSubTemplateIds',
	TemplateRelationChildList: 'Template.Relation.Child.list',
	TemplateRelationChildListByIds: 'Template.Relation.Child.listByIds',
	TemplateRelationRelatedAdd: 'Template.Relation.Related.add',
	TemplateRelationRelatedDelete: 'Template.Relation.Related.delete',
	TemplateRelationRelatedList: 'Template.Relation.Related.list',
	TemplateStateSet: 'Template.State.set',
	TemplateUpdate: 'Template.update',
	UserList: 'User.list',
	AbsenceGet: 'Absence.get',
	AbsenceView: 'Absence.view',
});
